module.exports = __webpack_public_path__ + "img/check-solid.d56e9824.svg";